import { FC } from 'react'

import { ArticleViewerContentRendererComponent } from '@/components/ActivityViewers/articleViewer/ArticleViewerContentRendererComponent'
import { useLearnerAllowedExternalSources } from '@/components/ActivityViewers/articleViewer/useLearnerAllowedExternalSources'

export const PDF_URL_QUERY_STR = 'pdfUrl'

type Props = {
  contentClassName: string
  html: {
    __html: string
  }
}

export const ArticleViewerContentRenderer: FC<Props> = ({ contentClassName, html }) => {
  const allowedExternalSources = useLearnerAllowedExternalSources(false)

  return (
    <ArticleViewerContentRendererComponent
      contentClassName={contentClassName}
      html={html}
      allowedExternalSources={allowedExternalSources}
    />
  )
}
